"use client";

import { ShoppingCartIcon } from "@phosphor-icons/react/dist/ssr/ShoppingCart";
import { useRouter } from "next/navigation";
import { useEffect } from "react";

import {
  ProfileType,
  applicationIsDenied,
  ownerStore,
  sync,
  useProfile,
  useTheme,
} from "@up/data";
import { LoadingError, LoadingModal, UPLink } from "@up/ui";

import { CohortSwitchDrawer } from "../courses/cohort-switch-drawer";
import { CourseInfo } from "../courses/course-info";
import { LoadOrders } from "../courses/load-orders";
import { LineItem } from "../line-item";
import { AppStatus } from "../profile/application-status";
import { ScholarshipStatusView } from "../profile/scholarship-status";

export function StudentsPage({ minimal = false }) {
  // Rework applicationStatus and scholarshipStatus once relationships is ready
  const router = useRouter();
  const theme = useTheme();
  const profile = useProfile();

  useEffect(() => {
    sync();
  }, []);

  useEffect(() => {
    if (profile?.data?.type === ProfileType.Student) {
      router.push("/profile");
    }
  }, [profile, router]);

  if (profile?.didError) {
    return (
      <div className="mb-8">
        <LoadingError
          error="Sorry, we could not load your profile"
          errorCode={profile.errorCode}
        />
      </div>
    );
  }

  if (profile?.data) {
    return (
      <div>
        <div className="flex flex-col gap-10 lg:gap-16">
          {profile.data.type === ProfileType.Guardian &&
          profile.data.relatedStudents?.length ? (
            <div>
              <div className="flex flex-col gap-8">
                {profile.data.relatedStudents.map((student) => {
                  return (
                    <div key={student._id}>
                      <h2 className={`${theme.heading2Class}`}>
                        {student.profile.firstName} {student.profile.lastName}
                      </h2>
                      <p className="mb-2">{student.profile.email}</p>
                      <AppStatus
                        isStudent={false}
                        status={student.application?.status}
                      />
                      {applicationIsDenied(
                        student.application?.status,
                      ) ? null : (
                        <ScholarshipStatusView
                          authenticatedProfileType={profile?.data?.type}
                          status={student.scholarship?.status}
                          targetContact={student}
                        />
                      )}
                      {applicationIsDenied(
                        student.application?.status,
                      ) ? null : (
                        <LineItem
                          as={UPLink}
                          compact={true}
                          href="/checkout"
                          Icon={ShoppingCartIcon}
                          onClick={() => {
                            ownerStore.set({
                              email: student.profile.email,
                              firstName: student.profile.firstName,
                              lastName: student.profile.lastName,
                              contactId: student._id,
                            });
                          }}
                        >
                          <div className="underline">
                            Enroll for {student.profile.firstName}
                          </div>
                        </LineItem>
                      )}

                      {student.orders?.length && !minimal ? (
                        <div className="mt-4">
                          <LoadOrders
                            orderIds={student.orders.map(
                              (order) => order.orderId,
                            )}
                          >
                            {({ courses, error, getCourses, isLoading }) => {
                              if (error) {
                                return (
                                  <LoadingError error="Sorry, we could not load your courses" />
                                );
                              }
                              return (
                                <div>
                                  {isLoading ? <LoadingModal /> : null}
                                  <CohortSwitchDrawer
                                    ownerContactId={student._id}
                                    successCallback={async () => {
                                      await sync();
                                      getCourses();
                                    }}
                                  />
                                  {courses?.map((course) => (
                                    <CourseInfo
                                      compact={true}
                                      course={course}
                                      key={course._id}
                                      isGuardian={true}
                                      enrollments={student.enrollments}
                                    />
                                  ))}
                                </div>
                              );
                            }}
                          </LoadOrders>
                        </div>
                      ) : null}
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
          <br />
        </div>
      </div>
    );
  } else if (profile?.isLoading) {
    return (
      <div>
        <LoadingModal />
      </div>
    );
  }

  return <div />;
}
